"use strict";

export const POPUP_SOURCES = Object.freeze({
	BRANDS: "brands",
	DASHBOARD: "dashboard",
});

export const BRAND_CARD_POPUP_SUPPORTED_SOURCES = new Set([POPUP_SOURCES.BRANDS, POPUP_SOURCES.DASHBOARD]);

export function resolvePopupSource(source, fallback = POPUP_SOURCES.BRANDS) {
	const fallbackSource = typeof fallback === "string" && fallback.trim() ? fallback.trim() : POPUP_SOURCES.BRANDS;
	if (typeof source !== "string") return fallbackSource;
	const normalisedSource = source.trim();
	return normalisedSource || fallbackSource;
}

export function isBrandsPopupSource(source) {
	return resolvePopupSource(source, POPUP_SOURCES.BRANDS) === POPUP_SOURCES.BRANDS;
}

export function isSupportedBrandCardPopupSource(source) {
	return BRAND_CARD_POPUP_SUPPORTED_SOURCES.has(resolvePopupSource(source, POPUP_SOURCES.BRANDS));
}
